module.exports = __webpack_public_path__ + "static/media/Croissant.6ca29a77.webp";